/*@ngInject*/
const LoadProfileImageRepository = function (baseCachedSharedPromiseRepository) {

    let sharedPromiseCache = {};

    angular.extend(this, baseCachedSharedPromiseRepository);

    this.getCacheName = function () {
        return 'loadProfileImageCache';
    };

    this.getCacheCapacity = function () {
        return 10;
    };

    this.getSharedPromiseCache = function () {
        return sharedPromiseCache;
    };

    this.loadProfileImage = function (profileId) {
        let url = '/rest/User/' + profileId + '/ProfileImage',
            cacheKey = 'userProfile:' + profileId;

        return this.get(cacheKey, url);
    };
};

angular.module('umCore')
    .service('loadProfileImageRepository', LoadProfileImageRepository);
